module.exports = __webpack_public_path__ + "Nexus7-black-landscape@2x.png?6e6557d683bb633608758c7f782fc77e";